import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { CarState } from './types';

type Variables = { id: number; reservationId: number };
type Response = CarState;

export const useCarStateRefresh = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id, reservationId }) =>
    client({
      url: `v2/cars/${id}/state/refresh`,
      method: 'POST',
      data: {
        reservation_id: reservationId,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
